import React from "react";
import { User } from "lucide-react";
import { PageHero, PageBody } from "./_shared";
import { usePoly } from "./PolyLayout";

export default function Leadership() {
  const data = usePoly();
  const list = data.leadership || [];
  return (
    <div data-testid="poly-leadership">
      <PageHero eyebrow="Leadership" title="Messages from the Leadership" accent="pink" />
      <PageBody>
        {list.length === 0 ? (
          <div className="text-center bg-white rounded-xl shadow p-12 text-slate-500">
            Messages will appear here once the institute publishes them.
          </div>
        ) : (
          <div className="space-y-8">
            {list.map((m, i) => (
              <article
                key={m.id}
                data-testid={`poly-leader-${m.designation.replace(/\s+/g, "-")}`}
                className={`bg-white rounded-xl shadow-md overflow-hidden flex flex-col md:flex-row ${
                  i % 2 === 1 ? "md:flex-row-reverse" : ""
                }`}
              >
                <div className="md:w-1/3 bg-gradient-to-br from-blue-600 via-indigo-600 to-purple-700 flex items-center justify-center p-8">
                  <div className="w-40 h-40 rounded-full overflow-hidden border-4 border-amber-400 shadow-lg bg-white">
                    {m.photo_url ? (
                      <img src={m.photo_url} alt={m.name} className="w-full h-full object-cover" />
                    ) : (
                      <div className="w-full h-full flex items-center justify-center text-blue-800">
                        <User size={48} strokeWidth={1.5} />
                      </div>
                    )}
                  </div>
                </div>
                <div className="flex-1 p-8">
                  <div className="text-[10px] tracking-[0.3em] uppercase text-amber-600 font-semibold">
                    {m.designation}
                  </div>
                  <h2 className="font-serif text-3xl text-slate-900 mt-1">{m.name || "—"}</h2>
                  <div
                    className="prose prose-slate max-w-none mt-4"
                    dangerouslySetInnerHTML={{ __html: m.message_html }}
                  />
                </div>
              </article>
            ))}
          </div>
        )}
      </PageBody>
    </div>
  );
}
